import Header from '../../components/Header'
import TrvInterface from "../../components/TrvInterface/TrvInterface"
import { ThreeDots } from "react-loader-spinner";

function Trv() {

    const dadosString = localStorage.getItem('trvDetalhe');
    const dadosJson = JSON.parse(dadosString);
    const dados = dadosJson;

    const mensagemErro = localStorage.getItem('erroTRV') ? localStorage.getItem('erroTRV') : 'TRV Indisponível';
    const mensagemCarregamento = localStorage.getItem('mensagemCarregamentoTRV');

    const carregandoTRV = localStorage.getItem('carregandoTRV');

    if (carregandoTRV) {
        return (
            <>
                <Header type="otherPage" />
                <div className='flex justify-center items-center'>
                    <span className='text-xl'>{mensagemCarregamento}</span>
                    <ThreeDots
                        height="8"
                        width="60"
                        radius="15"
                        color="#000000"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                    />
                </div>
            </>
        )
    }

    if (!dados) {
        return (
            <>
                <Header type="otherPage" />
                <div className='flex justify-center items-center'>
                    <span className='text-xl'>{mensagemErro}</span>
                </div>
            </>
        )
    }

    return (
        <>
            <Header type="otherPage" />
            <TrvInterface dados={dados} />
        </>
    )
}

export default Trv